module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tip_word"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("友情提示：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("1.请按照大V服务平台信息要求填写正确的供应商信息。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("3.提交审核之后，大V店工作人员会在3个工作日内进行审核。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("4.入驻过程有任何疑问，请按照如下方式解决："), _c('br'), _vm._v("（1）如果有对接的采销，请直接联系采销处理解决；"), _c('br'), _vm._v("（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("5."), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/suppliers/index2/#/intro"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#58b7ff"
    }
  }, [_vm._v("点击此处")])]), _vm._v("查看供应商入驻介绍。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl10 mt20"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSchedule),
      expression: "showSchedule"
    }],
    staticClass: "mt20 mb20"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("入驻进展：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.scheduleObj.schedule))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [(_vm.scheduleObj.content) ? _c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n                        (" + _vm._s(_vm.scheduleObj.content) + ")")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("基础信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    ref: "basicForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.basicForm,
      "rules": _vm.rules,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司名称",
      "prop": "supplierName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入营业执照注册的公司名称"
    },
    model: {
      value: (_vm.basicForm.supplierName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "supplierName", $$v)
      },
      expression: "basicForm.supplierName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib",
    attrs: {
      "label": "公司介绍",
      "prop": "supplierIntro"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "autosize": {
        minRows: 6,
        maxRows: 10
      },
      "type": "textarea",
      "placeholder": "请详细介绍公司信息，如行业地位等",
      "maxlength": 200
    },
    model: {
      value: (_vm.basicForm.supplierIntro),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "supplierIntro", $$v)
      },
      expression: "basicForm.supplierIntro"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "word_num"
  }, [_vm._v("您可以输入 "), _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.amount))]), _vm._v(" 个字")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "线上店铺",
      "prop": "otherPlatformShopUrl"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "其他平台商品、店铺的链接"
    },
    model: {
      value: (_vm.basicForm.otherPlatformShopUrl),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "otherPlatformShopUrl", $$v)
      },
      expression: "basicForm.otherPlatformShopUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib",
    attrs: {
      "label": "办公地址"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-select', {
    staticClass: "ml_10",
    attrs: {
      "placeholder": "请选择国家"
    },
    on: {
      "change": _vm.getOfficeProvince
    },
    model: {
      value: (_vm.basicForm.officeCountry),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeCountry", $$v)
      },
      expression: "basicForm.officeCountry"
    }
  }, _vm._l((_vm.countryList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign"
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isForeign,
      "placeholder": "请选择省份"
    },
    on: {
      "change": _vm.getOfficeCity
    },
    model: {
      value: (_vm.basicForm.officeProvince),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeProvince", $$v)
      },
      expression: "basicForm.officeProvince"
    }
  }, _vm._l((_vm.provinceList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign"
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isForeign,
      "placeholder": "请选择城市"
    },
    on: {
      "change": _vm.getOfficeDistrict
    },
    model: {
      value: (_vm.basicForm.officeCity),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeCity", $$v)
      },
      expression: "basicForm.officeCity"
    }
  }, _vm._l((_vm.cityList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign"
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isForeign,
      "placeholder": "请选择区县"
    },
    model: {
      value: (_vm.basicForm.officeDistrict),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeDistrict", $$v)
      },
      expression: "basicForm.officeDistrict"
    }
  }, _vm._l((_vm.districtList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "officeAddress",
      "label-width": "207px"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "autosize": {
        minRows: 4,
        maxRows: 6
      },
      "type": "textarea",
      "placeholder": "请输入您的详细地址"
    },
    model: {
      value: (_vm.basicForm.officeAddress),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeAddress", $$v)
      },
      expression: "basicForm.officeAddress"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("品类信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.applyStatus != 9),
      expression: " applyStatus != 9 "
    }],
    staticClass: "dib mt20",
    attrs: {
      "label": "申请主营品类："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star2 vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-select', {
    staticClass: "ml_10 vtb",
    attrs: {
      "placeholder": "请选择一级类目"
    },
    on: {
      "change": _vm.getTowList
    },
    model: {
      value: (_vm.cata.first),
      callback: function($$v) {
        _vm.$set(_vm.cata, "first", $$v)
      },
      expression: "cata.first"
    }
  }, _vm._l((_vm.oneList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.applyStatus != 9),
      expression: " applyStatus != 9 "
    }],
    staticClass: "dib sign"
  }, [_c('el-select', {
    staticClass: "vtb",
    attrs: {
      "placeholder": "请选择二级类目"
    },
    on: {
      "change": _vm.getThreeList
    },
    model: {
      value: (_vm.cata.second),
      callback: function($$v) {
        _vm.$set(_vm.cata, "second", $$v)
      },
      expression: "cata.second"
    }
  }, _vm._l((_vm.twoList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.applyStatus != 9),
      expression: " applyStatus != 9 "
    }],
    staticClass: "dib sign"
  }, [_c('el-select', {
    staticClass: "vtb",
    attrs: {
      "placeholder": "请选择三级类目"
    },
    on: {
      "change": _vm.selectInfo
    },
    model: {
      value: (_vm.cata.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.cata, "categoryId", $$v)
      },
      expression: "cata.categoryId"
    }
  }, _vm._l((_vm.threeList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.applyStatus != 9),
      expression: " applyStatus != 9 "
    }],
    staticClass: "vtb",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._v("添加合作类目")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "84%",
      "margin": "0 auto",
      "margin-bottom": "22px"
    },
    attrs: {
      "data": _vm.supplierApplyCategories,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "主营品类",
      "width": "300",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.category.grandName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.parentName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.childrenName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryDeposit",
      "label": "品类保证金",
      "width": "271",
      "align": "center"
    }
  }, [
    [_c('div', {
      staticClass: "red"
    }, [_c('el-table-column', {
      attrs: {
        "prop": "categoryDeposit",
        "label": "(只需上交保证金额最高的一个)",
        "width": "271",
        "align": "center"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "label": "品类经营特许资质电子版",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-upload', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.franchiseQualification),
            expression: "scope.row.franchiseQualification"
          }],
          staticClass: "hide_up",
          class: [scope.row.franchiseQualificationFile.length > 1 ? _vm.franchise[scope.$index] : ''],
          staticStyle: {
            "max-height": "149px",
            "overflow": "hidden"
          },
          attrs: {
            "action": "/suppliers/uploadImageData?biz=0",
            "name": "pic",
            "data": {
              data: scope.$index
            },
            "list-type": "picture-card",
            "file-list": scope.row.franchiseQualificationFile,
            "on-preview": _vm.handlePictureCardPreview,
            "on-remove": _vm.handleRemove,
            "on-success": _vm.handleUpload,
            "before-upload": _vm.beforeUpload
          }
        }, [_c('i', {
          staticClass: "el-icon-plus"
        })])]
      }
    }])
  }), _vm._v(" "), (_vm.applyStatus != 9) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.applyStatus != 9),
            expression: " applyStatus != 9 "
          }],
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除\n                                ")])]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dib mb20"
  }, [_vm._v("供应商资质信息")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBook),
      expression: "isBook"
    }],
    staticClass: "dib",
    attrs: {
      "label": "出版社经营许可证电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star3"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.publicationBusinessLicenseFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removePic1,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.handleSuccess1
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_1),
      expression: "pic_1"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册登记名称：",
      "prop": "registeredName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入注册登记名称"
    },
    model: {
      value: (_vm.basicForm.registeredName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredName", $$v)
      },
      expression: "basicForm.registeredName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib",
    attrs: {
      "label": "注册登记地址：",
      "prop": "registeredCountry"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isBook || _vm.applyStatus == 9,
      "placeholder": "请选择国家"
    },
    on: {
      "change": _vm.getRegisteredProvince
    },
    model: {
      value: (_vm.basicForm.registeredCountry),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredCountry", $$v)
      },
      expression: "basicForm.registeredCountry"
    }
  }, _vm._l((_vm.countryList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign"
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isRegisteredForeign,
      "placeholder": "请选择省份"
    },
    on: {
      "change": _vm.getRegisteredCity
    },
    model: {
      value: (_vm.basicForm.registeredProvince),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredProvince", $$v)
      },
      expression: "basicForm.registeredProvince"
    }
  }, _vm._l((_vm.registeredProvinceList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign"
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isRegisteredForeign,
      "placeholder": "请选择城市"
    },
    on: {
      "change": _vm.getRegisteredDistrict
    },
    model: {
      value: (_vm.basicForm.registeredCity),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredCity", $$v)
      },
      expression: "basicForm.registeredCity"
    }
  }, _vm._l((_vm.registeredCityList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign"
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isRegisteredForeign,
      "placeholder": "请选择区县"
    },
    model: {
      value: (_vm.basicForm.registeredDistrict),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredDistrict", $$v)
      },
      expression: "basicForm.registeredDistrict"
    }
  }, _vm._l((_vm.registeredDistrictList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "registeredAddress",
      "label-width": "207px"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "autosize": {
        minRows: 4,
        maxRows: 6
      },
      "type": "textarea",
      "placeholder": "请输入您的详细地址"
    },
    model: {
      value: (_vm.basicForm.registeredAddress),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredAddress", $$v)
      },
      expression: "basicForm.registeredAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册资金：",
      "prop": "registeredCapital",
      "rules": [{
          required: true,
          message: '注册资金不能为空'
        },
        {
          type: 'number',
          message: '请输入数字值'
        }
      ]
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入注册资金"
    },
    model: {
      value: (_vm.basicForm.registeredCapital),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredCapital", _vm._n($$v))
      },
      expression: "basicForm.registeredCapital"
    }
  }), _vm._v("\n                        （单位：万）\n                        "), _c('el-radio-group', {
    model: {
      value: (_vm.basicForm.registeredCapitalType),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredCapitalType", $$v)
      },
      expression: "basicForm.registeredCapitalType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("人民币")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("美元")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.licenseType != 3),
      expression: "basicForm.licenseType !=3"
    }],
    attrs: {
      "label": "执照类型："
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.licenseChange
    },
    model: {
      value: (_vm.basicForm.licenseType),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "licenseType", $$v)
      },
      expression: "basicForm.licenseType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("普通营业执照")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("三证合一／五证合一")])]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": 3
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("国外")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照号：",
      "prop": "businessLicenseCode",
      "rules": [{
          required: true,
          message: '营业执照号不能为空',
          trigger: 'blur'
        }

      ]
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入营业执照号"
    },
    model: {
      value: (_vm.basicForm.businessLicenseCode),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "businessLicenseCode", $$v)
      },
      expression: "basicForm.businessLicenseCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "营业执照电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star4"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.businessLicenseFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removePic2,
      "on-success": _vm.handleSuccess2,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_2),
      expression: "pic_2"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.registeredCountry == 1),
      expression: "basicForm.registeredCountry == 1"
    }],
    attrs: {
      "label": "执照有效期："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star105"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "ml_10",
    attrs: {
      "type": "daterange",
      "placeholder": "选择执照有效期"
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOneCertificate),
      expression: "isOneCertificate"
    }],
    attrs: {
      "label": "组织机构代码："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star2 vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    staticClass: "w500 ml_10",
    attrs: {
      "placeholder": "请输入组织机构代码"
    },
    model: {
      value: (_vm.basicForm.orgCode),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "orgCode", $$v)
      },
      expression: "basicForm.orgCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOneCertificate),
      expression: "isOneCertificate"
    }],
    staticClass: "dib mt20",
    attrs: {
      "label": "组织结构代码电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star5"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.orgCodeFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removePic3,
      "on-success": _vm.handleSuccess3,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_3),
      expression: "pic_3"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOneCertificate),
      expression: "isOneCertificate"
    }],
    staticClass: "dib mt20",
    attrs: {
      "label": "税务登记证电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star6"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), (!_vm.pic_4) ? [_c('div', {
    staticClass: "fixeds"
  })] : _vm._e(), _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.taxFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removePic4,
      "on-success": _vm.handleSuccess4,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_4),
      expression: "pic_4"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "开户许可证电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star6"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.accountOpeningPermitFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removePic5,
      "on-success": _vm.handleSuccess5,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_5),
      expression: "pic_5"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "法定代表人证件类型："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star5"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "ml_10",
    model: {
      value: (_vm.basicForm.personalCardType),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "personalCardType", $$v)
      },
      expression: "basicForm.personalCardType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("身份证")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("护照")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "法定代表人身份证件电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star200"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("身份证正反两面，同一张A4纸，复印件请加盖公司红章")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.personalCardFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removePic6,
      "on-success": _vm.handleSuccess6,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_6),
      expression: "pic_6"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "dib"
  }, [_vm._v("业务联系人信息")]), _c('span', {
    staticClass: "second_line"
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "联系人姓名:",
      "prop": "contactName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人姓名",
      "maxlength": 5
    },
    model: {
      value: (_vm.basicForm.contactName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactName", $$v)
      },
      expression: "basicForm.contactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人手机号:",
      "prop": "contactMobile"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人手机号"
    },
    model: {
      value: (_vm.basicForm.contactMobile),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactMobile", $$v)
      },
      expression: "basicForm.contactMobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人座机:"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人座机"
    },
    model: {
      value: (_vm.basicForm.contactLandline),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactLandline", $$v)
      },
      expression: "basicForm.contactLandline"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱:",
      "prop": "contactEmail",
      "rules": [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }
      ]
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人邮箱"
    },
    model: {
      value: (_vm.basicForm.contactEmail),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactEmail", $$v)
      },
      expression: "basicForm.contactEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人QQ:",
      "prop": "contactQQ"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人QQ"
    },
    model: {
      value: (_vm.basicForm.contactQQ),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactQQ", $$v)
      },
      expression: "basicForm.contactQQ"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职务:",
      "prop": "contactPosition"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "number": "",
      "placeholder": "请输入联系人职务"
    },
    model: {
      value: (_vm.basicForm.contactPosition),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactPosition", _vm._n($$v))
      },
      expression: "basicForm.contactPosition"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "dib"
  }, [_vm._v("合同联系人信息")]), _c('span', {
    staticClass: "second_line"
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "联系人姓名:",
      "prop": "contractContactName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人姓名",
      "maxlength": 5
    },
    model: {
      value: (_vm.basicForm.contractContactName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactName", $$v)
      },
      expression: "basicForm.contractContactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人手机号:",
      "prop": "contractContactMobile"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人手机号"
    },
    model: {
      value: (_vm.basicForm.contractContactMobile),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactMobile", $$v)
      },
      expression: "basicForm.contractContactMobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人座机:"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人座机"
    },
    model: {
      value: (_vm.basicForm.contractContactLandline),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactLandline", $$v)
      },
      expression: "basicForm.contractContactLandline"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱:",
      "prop": "contractContactEmail",
      "rules": [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }
      ]
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人邮箱"
    },
    model: {
      value: (_vm.basicForm.contractContactEmail),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactEmail", $$v)
      },
      expression: "basicForm.contractContactEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人QQ:",
      "prop": "contractContactQQ"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人QQ"
    },
    model: {
      value: (_vm.basicForm.contractContactQQ),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactQQ", $$v)
      },
      expression: "basicForm.contractContactQQ"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职务:",
      "prop": "contractContactPosition"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "number": "",
      "placeholder": "请输入联系人职务"
    },
    model: {
      value: (_vm.basicForm.contractContactPosition),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactPosition", _vm._n($$v))
      },
      expression: "basicForm.contractContactPosition"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "dib"
  }, [_vm._v("客服联系人信息")]), _c('span', {
    staticClass: "second_line"
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "联系人姓名:",
      "prop": "customContactName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人姓名",
      "maxlength": 5
    },
    model: {
      value: (_vm.basicForm.customContactName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customContactName", $$v)
      },
      expression: "basicForm.customContactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人手机号:",
      "prop": "customContactMobile"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人手机号"
    },
    model: {
      value: (_vm.basicForm.customContactMobile),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customContactMobile", $$v)
      },
      expression: "basicForm.customContactMobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人座机:"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人座机"
    },
    model: {
      value: (_vm.basicForm.customContactLandline),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customContactLandline", $$v)
      },
      expression: "basicForm.customContactLandline"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱:",
      "prop": "customContactEmail",
      "rules": [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }
      ]
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人邮箱"
    },
    model: {
      value: (_vm.basicForm.customContactEmail),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customContactEmail", $$v)
      },
      expression: "basicForm.customContactEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人QQ:",
      "prop": "customContactQQ"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人QQ"
    },
    model: {
      value: (_vm.basicForm.customContactQQ),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customContactQQ", $$v)
      },
      expression: "basicForm.customContactQQ"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职务:",
      "prop": "customContactPosition"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "number": "",
      "placeholder": "请输入联系人职务"
    },
    model: {
      value: (_vm.basicForm.customContactPosition),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customContactPosition", _vm._n($$v))
      },
      expression: "basicForm.customContactPosition"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt50",
    attrs: {
      "label-width": "207px"
    }
  }, [(_vm.applyStatus == 0 || _vm.applyStatus == 1) ? _c('el-button', {
    staticClass: "mr30",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveForm
    }
  }, [_vm._v("保存草稿")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('basicForm')
      }
    }
  }, [_vm._v("下一步，完善品牌信息")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_top"
  }, [_c('div', {
    staticClass: "edit_tab active_tab"
  }, [_vm._v("供应商信息")]), _c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("品牌信息")]), _c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("财务信息")]), _c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("合同协议")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba8942fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/edit/basicInfo.vue
// module id = 568
// module chunks = 0